import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useChangeGroupGenerationActions} from '../stores/selectors'
import type {ChangeGroupPayload} from '../types/group-types'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'

/**
 * manually trigger the generation of change groups
 */
export function useGenerateChangeGroupsMutation() {
  const apiURL = usePageDataUrl(PageData.generateChangeGroups)
  const {updateChangeGroupGeneration} = useChangeGroupGenerationActions()

  return useMutation({
    mutationFn: async () => {
      const response = await fetchWithErrorHandling(apiURL, {
        method: 'POST',
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: ChangeGroupPayload) => {
      // Update Zustand store immediately when data is fetched
      updateChangeGroupGeneration(data)
    },
  })
}
